module.exports = __webpack_public_path__ + "img/stock5.5a0d7cc5.png";